var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69668 10.3434C5.52358 10.3434 4.33176 9.64698 3.6362 8.72525C0.299119 8.72525 0.198242 13.4925 0.198242 13.4925H13.1943C13.1943 13.4925 13.4563 8.7041 9.70347 8.7041C9.00872 9.63722 7.86979 10.3434 6.69668 10.3434Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49175 4.62822C9.49175 5.99983 8.23974 8.62263 6.69404 8.62263C5.15078 8.62263 3.89795 5.99901 3.89795 4.62822C3.89795 3.25743 5.14996 2.14453 6.69404 2.14453C8.23974 2.14534 9.49175 3.25825 9.49175 4.62822Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7401 3.44464C10.7401 3.18757 10.3821 2.98012 9.93795 2.97849V2.44889C9.93795 2.36998 9.96805 0.522461 6.70419 0.522461C3.44195 0.522461 3.47205 2.36998 3.47205 2.44889V2.99721C3.46392 2.99721 3.45741 2.99477 3.45009 2.99477C3.00834 2.99477 2.65283 3.19896 2.65283 3.45197V5.69242C2.65283 5.94379 3.00916 6.1488 3.45009 6.1488C3.89102 6.1488 4.24897 5.94379 4.24897 5.69242V3.45197C4.24897 3.41698 4.227 3.38526 4.21399 3.35272V2.74176C4.21399 2.68563 3.97969 1.29124 6.70419 1.29124C9.4295 1.29124 9.14639 2.68563 9.14639 2.74176V3.38526C9.14151 3.4056 9.12605 3.42349 9.12605 3.44464V5.73635C9.12605 5.99423 9.48645 6.20331 9.93307 6.20331C9.94283 6.20331 9.95016 6.20006 9.95992 6.20006V7.03717H9.15941V7.82629H10.7482L10.7401 3.44464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.4895db5a.svg";
export { ForwardRef as ReactComponent };